import { api } from '@/utils/api';
import { ControlKpiResponse, Configuration, ApiResponse } from './controlkpi';
import { InspectDatsRequest } from './Inp';

export default class InpRepository {
  async getModelFilesByOrganization({
    organizationId,
    page,
    size,
    name,
    locationId,
    onlyCompleted,
    hasControlKpi
  }: {
    organizationId: number;
    page: number;
    size: number;
    name?: string | null;
    locationId?: number | null;
    onlyCompleted?: boolean | null;
    hasControlKpi?: boolean | null;
  }) {
    const response = await api.get(
      `/inps/uploads/organizations/${organizationId}`,
      { params: { page, size, name, locationId, onlyCompleted,hasControlKpi } },
    );
    return response.data;
  }

  async uploadInps(
    userId: string,
    organizationId: string,
    data: any,
  ): Promise<boolean> {
    const locations = await api.post(
      `/inps/uploads/users/${userId}/organizations/${organizationId}`,
      data,
    );
    return locations.data;
  }
  async getDatsFromInp(data: InspectDatsRequest): Promise<string[]> {
    const response = await api.post('/inps/inspect/dats', data);
    return response.data;
  }

  async changeStatusInp(inpId: any, status: boolean): Promise<boolean> {
    const response = await api.post(`/inps/${inpId}/status`, {
      status,
    });
    return response.data;
  }

  async getModelInfrastructureId(
    inpId: any,
    typeId: any,
    name: string | null,
    page: number = 1,
    size: number = 10000,
    assetType: string | null = null,
  ): Promise<any> {
    const response = await api.get(`inps/${inpId}/assets`, {
      params: {
        page,
        size,
        typeId,
        name,
        assetType,
      },
    });
    return response.data;
  }

  async enableInp(inpId: string | number, enabled: boolean): Promise<boolean> {
    const response = await api.put(`inps/${inpId}?enabled=${enabled}`);
    return response.data;
  }

  async disableInp(inpId: string | number, enabled: boolean): Promise<boolean> {
    const response = await api.put(`inps/${inpId}?enabled=${enabled}`);
    return response.data;
  }
  async deleteInps(inpId: number): Promise<boolean> {
    const response = await api.delete(`inps/${inpId}`);
    return response.data;
  }

  async saveBaseline(
    inpId: number | string,
    data: { inpBaselineName: string; inpData: string },
  ): Promise<any> {
    const response = await api.post(`/inps/${inpId}/baseline`, data);
    return response.data;
  }

  async deleteBaseline(inpId: number | string): Promise<any> {
    const response = await api.delete(`/inps/${inpId}/baseline`);
    return response.data;
  }

  async getControlKpi(inpId: number): Promise<ControlKpiResponse[]> {
    const response = await api.get(`/inps/controlkpi/${inpId}`);
    return response.data;
  }

  async saveControlKpi({
    inpId,
    locationId,
    configuration
  }: {
    inpId: number;
    locationId: number;
    configuration: Configuration;
  }): Promise<ApiResponse> {
    const response = await api.post('/inps/controlkpis', {
      inpId,
      locationId,
      configuration
    });
    return response.data;
  }

  async deleteControlKpi(inpId: number): Promise<ApiResponse> {
    const response = await api.delete(`/inps/controlkpi/${inpId}`);
    return response.data;
  }
}
